// App.js
import { ThemeProvider, createTheme } from "@mui/material/styles";
import KrishnaPrasadamSearch from "./KrishnaPrasadamSearch";
import "./index.css";

const theme = createTheme({
  typography: {
    fontFamily: '"Open Sans", sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <KrishnaPrasadamSearch />
    </ThemeProvider>
  );
}

export default App;
